// Move-out notice period — mirror of the server's `utils/noticePeriod.js`.
//
// The server makes the actual decision (validation happens there), but the
// form needs to know upfront what the earliest possible date is — otherwise
// the user fills out the whole form and only then gets a 400 on submit.
//
// Rule: if the tenant is vacating, use tenantNoticePeriod; if the owner is
// vacating them, use ownerNoticePeriod; if no setting exists, fall back to
// the property's agreement noticePeriod; if that's also missing, use 1 month.

const SETTING_NOTICE_DAYS = {
  "7 Days": 7,
  "15 Days": 15,
  "30 Days": 30,
  "60 Days": 60,
  "90 Days": 90,
};

const FLAT_NOTICE_DAYS = {
  "15_days": 15,
  "1_month": 30,
  "2_months": 60,
  "3_months": 90,
};

export const DEFAULT_NOTICE_DAYS = 30;

/**
 * @param {object} opts
 * @param {object|null} opts.setting  PropertySetting applied to the flat
 * @param {object} opts.flat          property detail
 * @param {"LANDLORD"|"TENANT"} opts.initiatedBy
 */
export const noticeDaysFor = ({
  setting = null,
  flat = {},
  initiatedBy = "TENANT",
} = {}) => {
  const isLandlord = String(initiatedBy).toUpperCase() === "LANDLORD";

  const rule = isLandlord
    ? setting?.ownerNoticePeriod
    : setting?.tenantNoticePeriod;

  if (rule && SETTING_NOTICE_DAYS[rule] !== undefined) {
    return SETTING_NOTICE_DAYS[rule];
  }

  if (flat?.noticePeriod && FLAT_NOTICE_DAYS[flat.noticePeriod] !== undefined) {
    return FLAT_NOTICE_DAYS[flat.noticePeriod];
  }

  return DEFAULT_NOTICE_DAYS;
};

/** YYYY-MM-DD — the date input requires this exact format. */
export const earliestMoveOutDate = (days = DEFAULT_NOTICE_DAYS, from = new Date()) => {
  const d = new Date(from);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + Number(days || 0));
  return d.toISOString().split("T")[0];
};

/** Whichever of two YYYY-MM-DD dates comes later. */
export const laterDate = (a, b) => {
  if (!a) return b;
  if (!b) return a;
  return a > b ? a : b;
};
